<template>
  <div class="car-details" v-loading="oLoading.detail">
    <QS-scroller-box>
      <QS-h3-title>
        <template slot="title">{{ pageTitle }}</template>
        <div class="splitline" />
      </QS-h3-title>
      <template>
        <section class="item">
          <QS-h4-title title="车辆信息" />
          <column-box
              :source="carInfoVo"
              :list="carInfoList"
              :labelWidth="130"
          ></column-box>
        </section>
        <section class="item">
          <QS-h4-title title="交接信息" />
          <el-form ref="stockRef" :model="stock" :rules="rulesStock">
            <column-box :labelWidth="160" :column="2">
              <el-form-item
                prop="actualTakeOverName"
                :label="'提车人姓名' + columnSeparator"
              >
                <el-input
                  v-model="stock.actualTakeOverName"
                  clearable
                  maxlength="20"
                  placeholder="请输入提车人姓名"
                />
              </el-form-item>
              <el-form-item
                prop="actualTakeOverTel"
                :label="'提车人联系电话' + columnSeparator"
              >
                <el-input
                  v-model="stock.actualTakeOverTel"
                  clearable
                  v-number:phone
                  placeholder="请输入提车人联系电话"
                />
              </el-form-item>
              <el-form-item
                prop="takeOverManager"
                :label="'交接车管' + columnSeparator"
              >
                <el-select
                  v-model="stock.takeOverManager"
                  placeholder="请选择交接车管"
                  clearable
                  filterable
                >
                  <el-option
                    v-for="item in carTubeList"
                    :label="item.userName"
                    :value="item.id"
                    :key="item.id"
                  />
                </el-select>
              </el-form-item>
              <el-form-item
                prop="displayMile"
                :label="'表显里程' + columnSeparator"
              >
                <el-input
                  v-number:km
                  v-model="stock.displayMile"
                  placeholder="请输入表显里程"
                  clearable
                >
                  <template slot="append">公里</template>
                </el-input>
              </el-form-item>
              <el-form-item
                prop="remainingReserves"
                :label="'剩余电量/油量' + columnSeparator"
              >
                <el-input
                  v-model="stock.remainingReserves"
                  clearable
                  maxlength="20"
                />
              </el-form-item>
              <el-form-item
                prop="takeOverTime"
                :label="'交接完成时间' + columnSeparator"
              >
                <el-date-picker
                  v-model="stock.takeOverTime"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="datetime"
                  placeholder="请选择交接完成时间"
                  clearable
                  :picker-options="takeOverTimeOption"
                  :disabled="timeDisabled"
                />
                <p class="form-item-tips-red">
                  交接完成时间将影响后续退车核算相关费用，请务必准确填写
                </p>
              </el-form-item>

              <el-form-item prop="hasKey" :label="'车钥匙' + columnSeparator">
                <el-radio-group v-model="stock.hasKey">
                  <el-radio :label="1">有钥匙</el-radio>
                  <el-radio :label="0">无钥匙</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item
                prop="hasCarLicense"
                :label="'行驶证' + columnSeparator"
              >
                <el-radio-group v-model="stock.hasCarLicense">
                  <el-radio :label="1">有行驶证</el-radio>
                  <el-radio :label="0">无行驶证</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item
                :label="'备注' + columnSeparator"
                class="textare205"
              >
                <el-input
                  v-model="stock.remarks"
                  type="textarea"
                  placeholder="请输入备注"
                  maxlength="500"
                  show-word-limit
                  clearable
                />
              </el-form-item>
            </column-box>
          </el-form>
        </section>
        <section v-if="Number(sourceType) === 3 && Number(stockType) === 2">
          <QS-h4-title title="收车信息" />
          <el-form :model="recallCar">
            <column-box :labelWidth="160" :column="2">
              <el-form-item :label="'收车费用' + columnSeparator">
                <el-input
                  @input="val => amountInput(val)"
                  placeholder="请输入收车费用"
                  v-model="recallCar.recallAmount"
                  clearable
                  @change="amountChange"
                />
              </el-form-item>
            </column-box>
          </el-form>
        </section>
        <section>
          <QS-h4-title title="验车照片" />
          <div class="upload-box">
            <p class="upload-box__title">
              车况照片
              <span class="sub-title-line">（可批量上传最多{{photoPlusLimit}}张）</span>
            </p>
            <div class="upload-box__content">
              <p class="upload-box__content__subtitle">门店上传</p>
              <UploadCommon
                :fileList="photoPlus"
                :limit="photoPlusLimit"
                :multiple="true"
                :sizeType="4"
                :fileTitle="`最多上传${photoPlusLimit}张`"
                fileTitleWidth="240px"
                :isAlone="false"
                :showUploadBtnByLimit="photoPlusLimit"
                commonUpload
                group="order"
                code="order_vehicle_pic"
              />
            </div>
            <div class="upload-box__content">
              <p class="upload-box__content__subtitle">司机上传</p>
              <UploadCommon
                v-if="confirmPhoto.length > 0"
                :fileList="confirmPhoto"
                :limit="20"
                :multiple="true"
                :sizeType="4"
                fileTitleWidth="240px"
                :isAlone="false"
                :readonly="true"
                commonUpload
                group="order"
                code="order_vehicle_pic"
              />
              <div v-else>--</div>
            </div>
          </div>
          <div class="upload-box">
            <p class="upload-box__title">
              验车交接文件照片
              <span class="sub-title-line">（可批量上传最多10张）</span>
            </p>
            <div class="upload-box__content">
              <p class="upload-box__content__subtitle">门店上传</p>
              <UploadCommon
                :fileList="inspectionAttachmentPlus"
                :limit="10"
                :multiple="true"
                :sizeType="4"
                fileTitle="最多上传10张"
                fileTitleWidth="240px"
                :isAlone="false"
                commonUpload
                group="vehicle"
                code="vehicle_inspection_file"
              />
            </div>
          </div>
        </section>
      </template>
      <template slot="bottomAction">
        <el-button @click="goPageBack" size="mini">取消</el-button>
        <el-button
          v-if="stockId && judgePermission('vehicle_stock_edit')"
          :loading="oLoading.submit"
          @click="submitStockEditHandle"
          type="primary"
          size="mini"
        >提交保存</el-button>
        <el-button
          v-if="!stockId && judgePermission('vehicle_stock_submit')"
          :loading="oLoading.submit"
          @click="submitStockAddHandle"
          type="primary"
          size="mini"
        >完成交接</el-button>
      </template>
    </QS-scroller-box>
  </div>
</template>
<script>
// eslint-disable-next-line import/no-cycle
import { addOutIn, editOutIn, getCarAndContractData, getOutInDetails, getTempOutInDetails } from '@/api/domain/cars'
import { getAllEmployeeList } from '@/api/carManage/index.js'
import CARDICT from '@/store/dict/carDict.js'
import SelectOption from '@/store/dict/selectOptionDict'
import { formatDate } from '@/utils'
import { getContactNumber } from '@/utils/extendFormVaildate'
import { isIntiger, limitMoreZero } from '@/utils/validate'
import moment from 'moment'
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'OperationOutIn',
  data() {
    return {
      // 验车交接文件
      inspectionAttachmentPlus: [],
      // 车辆相关照片-门店上传
      photoPlus: [],
      // 车辆相关照片-司机上传
      confirmPhoto: [],
      oLoading: {
        detail: false,
        submit: false,
      },
      stockType: -1, // 出入库类型
      sourceType: '-1', // 出入库来源类型
      carId: '',
      stockId: '',
      pageSize: 10,
      pageNum: 1,
      customerList: [],
      // 设置默认付款方
      defaultCustomer: {
        id: '',
        list: [],
      },
      stockInfoVo: {},
      carInfoVo: {},
      carInfoList: [
        { key: 'plateNo', name: '车牌号' },
        { key: 'brandName', name: '品牌' },
        { key: 'seriesName', name: '车系' },
        { key: 'name', name: '车型' },
        { key: 'customerName', name: '提车人姓名' },
        { key: 'contactTel', name: '提车人手机号' },
        { key: 'vin', name: '车架号（VIN码）' },
      ],
      // 以前的合同信息
      contractInfoVo: {},
      // 现在的个人租赁订单信息
      rentOrderVO: {},
      addData: {
        customerId: '',
      },
      carTubeList: [], // 车管
      recallCar: {
        // 收车信息
        recallAmount: '', // 收车费用
      },
      stock: {
        displayMile: '',
        takeOverManager: '',
        takeOverTime: '',
        remarks: '',
        actualTakeOverName: '',
        actualTakeOverTel: '',
        remainingReserves: '',
        hasKey: '', // 是否有钥匙 0无 1有
        hasCarLicense: '', // 是否有行驶证 0无 1有
        isConfirm: 1, // 是否需要线上验车（此页面为换车出库，因换车为后台单，所以不需要进行线上验车，因此传1）
      },
      // 出入库校验
      rulesStock: {
        displayMile: [
          {
            validator: isIntiger,
            trigger: 'blur',
          },
          {
            required: true,
            message: '不能为空',
            trigger: 'blur',
          },
        ],
        takeOverManager: [
          {
            required: true,
            message: '不能为空',
            trigger: ['blur', 'change'],
          },
        ],
        takeOverTime: [
          {
            required: true,
            message: '不能为空',
            trigger: 'blur',
          },
        ],
        hasKey: [
          {
            required: true,
            message: '请选择',
            trigger: 'change',
          },
        ],
        hasCarLicense: [
          {
            required: true,
            message: '请选择',
            trigger: 'change',
          },
        ],
        remarks: [
          {
            required: true,
            message: '不能为空',
            trigger: 'blur',
          },
        ],
        actualTakeOverName: [
          {
            required: true,
            message: '不能为空',
            trigger: 'blur',
          },
        ],
        actualTakeOverTel: [
          {
            required: true,
            trigger: 'blur',
            validator: getContactNumber,
          },
          {
            min: 11,
            max: 11,
            message: '格式不正确',
            trigger: 'blur',
          },
        ],
        remainingReserves: [
          {
            required: true,
            message: '不能为空',
            trigger: 'blur',
          },
        ],
      },
      payDataList: [],
      payDataListSlice: [],
      orderState: '', // 订单状态
      unableChangeTime: false, // 是否禁止修改交接时间
    }
  },
  computed: {
    ...mapGetters(['rentMallOpenSwitch']),
    ...mapState({
      userInfo: (state) => state.user.userInfo,
    }),
    takeOverTimeOption() {
      /**
       * 出库-1：租赁设置中的签约时间-30天 <= 车辆交接时间 <= 当前时间
       * 入库-2：订单出库时间 <= 车辆交接时间 <= 当前时间
       * */
      if (Number(this.stockType) === 1) {
        const signDate = this?.rentOrderVO?.signDate || ''
        return {
          disabledDate: (time) => {
            return (
              moment(time).isBefore(moment(signDate).subtract(30, 'days')) ||
              moment(time).isAfter(moment())
            )
          },
        }
      }
      if (Number(this.stockType) === 2) {
        const outStockTime = this?.rentOrderVO?.outStockTime || ''
        return {
          disabledDate: (time) => {
            return (
              time.getTime() < new Date(outStockTime).getTime() - 8.64e7 ||
              time.getTime() > Date.now()
            )
          },
        }
      }
      return null
    },
    // 出库交接完成时间是否禁用
    timeDisabled() {
      // 入库 && 订单核算后（订单状态为：费用待结算、已完成）时交接完成时间不可编辑
      //  this.stockType-1:出库，2:入库 orderState-5000:费用待结算，5500:已完成
      const { stockType, orderState, unableChangeTime } = this
      return (Number(orderState) >= 5000 && Number(stockType) === 2) || unableChangeTime
    },
    // 页面标题
    pageTitle() {
      const mode = this.$route.query?.stockId ? '编辑' : '创建'
      const type = CARDICT.OUT_INT_TYPE()[this.stockType] || '出入库'
      return `${mode}${type}记录`
    },
    // 车况图片限制，出库限制为20张 入库限制为80张
    photoPlusLimit() {
      return this.stockType === 1 ? 20 : 80
    },
  },
  mounted() {
    const { query } = this.$route
    if (query.stockId) {
      if (query.stockId) {
        this.stockId = parseInt(query.stockId)
      }
    }

    if (query.carId) {
      this.carId = parseInt(query.carId)
    }

    if (query.type) {
      this.stockType = Number(query.type)
    }
    // 获取车管
    this.getCarTubeList()
    // 没有出入库ID 代表新增
    if (query.stockId) {
      this.getOutInDetails()
    } else {
      this.getCarAndContractData()
    }
  },
  methods: {
    // 校验收车费用
    amountInput(value) {
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      const self = this
      limitMoreZero(
        value,
        (res) => {
          self.recallCar.recallAmount = res
        },
        7,
      )
    },
    amountChange(val) {
      this.recallCar.recallAmount = val > 0 ? val : ''
    },
    //  获取车管
    async getCarTubeList() {
      const { code, data } = await getAllEmployeeList()
      if (code === 1) {
        this.carTubeList = data
      } else {
        this.$message.error('获取车管失败')
      }
    },

    // 设置默认客户
    setDefaultCustomer() {
      if (this.defaultCustomer.id) {
        this.addData.customerId = this.defaultCustomer.id
        this.customerList = [...this.defaultCustomer.list]
      }
      this.addData.customerId = ''
    },

    // 获取详情回显数据
    async getOutInDetails() {
      this.oLoading.detail = true
      const dataList = await Promise.allSettled([
        getTempOutInDetails({ id: this.stockId }),
        getOutInDetails({ id: this.stockId }),
      ])
      const { data, code } = dataList[1].value
      // 获取出入库记录提交确认信息
      const tempData =
        dataList[0] && dataList[0].value.code === 1 && dataList[0].value.data
      this.oLoading.detail = false

      if (code === 1) {
        // sourceType:3强收车；stockType：2入库；recallAmount收车费用
        if (
          Number(data.stockInfoVo.sourceType) === 3 &&
          Number(data.stockInfoVo.type) === 2
        ) {
          this.recallCar.recallAmount = data.recallAmount
        }
        this.stockId = data.stockInfoVo.stockId
        this.stockType = data.stockInfoVo.type
        this.stockInfoVo = { ...data.stockInfoVo }
        this.stockInfoVo.typeName = CARDICT.OUT_INT_TYPE()[
          this.stockInfoVo.type
        ]
        this.carInfoVo = { ...data.carInfoVo,
          contactTel: data.rentOrderVO.contactTel,
          customerName: data.rentOrderVO.customerName,
          startDate: `${data.rentOrderVO.effectDate}至${data.rentOrderVO.endDate}`,
          rentCategoryName: data.rentOrderVO.rentCategoryName,
        }
        // 合同
        if (data.rentOrderVO) {
          this.rentOrderVO = { ...data.rentOrderVO }
          this.rentOrderVO.state =
            SelectOption.leaseOrderState[this.rentOrderVO.state]
          // 这期不根据状态进行判断直接添加应收弹窗默认值
          if (data.rentOrderVO.state || true) {
            // 设置默认用户数据
            this.defaultCustomer.id = data.rentOrderVO.customerNameId
            this.defaultCustomer.list.push({
              id: this.defaultCustomer.id,
              customerName: data.rentOrderVO.customerName,
              customerTel: data.rentOrderVO.contactTel,
            })
            this.setDefaultCustomer()
            this.addData.customerId = this.defaultCustomer.id
          }
        }

        // 编辑赋
        if (this.stockId) {
          const { userInfo, carTubeList } = this
          // 获取当前登录用户id
          const { id } = userInfo
          let takeOverManager
          // 如果在交接车管列表中存在登录人信息id则展示当前登录人信息
          if (carTubeList.find((item) => item.id === id)) {
            takeOverManager = id
          }
          this.stock.displayMile = data.stockInfoVo.displayMile
          this.stock.takeOverTime =
            data.stockInfoVo.takeOverTime ||
            formatDate(new Date(), 'YYYY-MM-DD HH:mm:ss')
          this.stock.takeOverManager =
            data.stockInfoVo.takeOverManager || takeOverManager || ''
          this.stock.remarks = data.stockInfoVo.remarks
          this.stock.actualTakeOverName =
            data.stockInfoVo.actualTakeOverName || tempData.actualTakeOverName
          this.stock.actualTakeOverTel =
            data.stockInfoVo.actualTakeOverTel || tempData.actualTakeOverTel
          this.stock.remainingReserves = data.stockInfoVo.remainingReserves

          // 有无行驶证回显
          if (data.stockInfoVo.hasCarLicense !== null) {
            this.stock.hasCarLicense = Number(data.stockInfoVo.hasCarLicense)
          }
          // 有无钥匙回显
          if (data.stockInfoVo.hasKey !== null) {
            this.stock.hasKey = Number(data.stockInfoVo.hasKey)
          }
          // 处理车况照片-门店上传
          const photoPlusObj = {
            remark: [],
            urlList: [],
          }
          data.stockInfoVo.photoPlus?.forEach((item) => {
            if (item.remark) {
              photoPlusObj.remark.push(item.remark)
            }
            if (Array.isArray(item.urlList) && item.urlList.length) {
              item.urlList.forEach((url) => {
                photoPlusObj.urlList.push({
                  url,
                })
              })
            }
          })
          this.photoPlus = photoPlusObj.urlList
          // 处理验车交接文件
          const inspectionAttachmentPlusObj = {
            remark: [],
            urlList: [],
          }
          data.stockInfoVo.inspectionAttachmentPlus?.forEach((item) => {
            if (item.remark) {
              inspectionAttachmentPlusObj.remark.push(item.remark)
            }
            if (Array.isArray(item.urlList) && item.urlList.length) {
              item.urlList.forEach((url) => {
                inspectionAttachmentPlusObj.urlList.push({
                  url,
                })
              })
            }
          })
          this.inspectionAttachmentPlus = inspectionAttachmentPlusObj.urlList
          // 处理司机上传
          if (data.stockInfoVo.confirmPhoto) {
            const confirmPhotoList = JSON.parse(data.stockInfoVo.confirmPhoto)
            this.confirmPhoto = confirmPhotoList.map((item) => {
              return {
                url: item,
              }
            })
          }
          this.orderState = data?.rentOrderVO?.state || '' // 订单状态
          this.unableChangeTime = data?.unableChangeTime || false // 是否禁止修改交接时间
        }

        // 已存在的应付列表
        this.payDataList = data.collectionInfoVo ? data.collectionInfoVo : []
        this.payDataList.forEach((item) => {
          item.isGetData = true
        }) // 证明是从数据库拿到的数据
        this.getPageData()
      }
    },

    // 获取车辆合同信息
    async getCarAndContractData() {
      const { code, data } = await getCarAndContractData({
        carId: this.carId,
      })
      if (code === 1) {
        this.stockInfoVo = {
          typeName: CARDICT.OUT_INT_TYPE()[this.stockType],
        }
        this.carInfoVo = { ...data.carInfoVo }
        this.contractInfoVo = { ...data.contractInfoVo }
        this.contractInfoVo.state =
          SelectOption.contractSignStateDict[this.contractInfoVo.state]
        if (data.contractInfoVo) {
          this.stock.actualTakeOverName = data.contractInfoVo.customerName
        }
        if (data.contractInfoVo) {
          this.stock.actualTakeOverTel = data.contractInfoVo.contactTel
        }
      }
    },
    // 新增出库记录
    submitStockAddHandle() {
      this.$refs.stockRef.validate(async (valid) => {
        if (valid) {
          this.oLoading.submit = true
          const data = this.parseSendData()
          const { code } = await addOutIn(data)
          this.oLoading.submit = false
          if (code === 1) {
            this.$message.success('添加成功')
            this.goPageBack(true)
          }
        } else {
          this.$message.error('请填写必填项')
        }
      })
    },
    // 编辑出库记录
    submitStockEditHandle() {
      this.$refs.stockRef.validate((valid, obj) => {
        if (valid) {
          this.oLoading.submit = true
          const data = this.parseSendData()
          delete data?.stockLog
          // 商城关闭，删除 isConfirm
          if (!this.rentMallOpenSwitch) {
            delete data.isConfirm
          }
          editOutIn(data)
            .then(({ code }) => {
              this.oLoading.submit = false
              if (code === 1) {
                this.$message.success('编辑成功')
                this.goPageBack(true)
              }
            })
            .catch((err) => {
              this.oLoading.submit = false
            })
        } else {
          if (Object.hasOwnProperty.call(obj, 'actualTakeOverTel')) {
            this.$message.error('提车人联系电话格式不正确，请输入正确的手机号')
            return
          }
          this.$message.error('请填写必填项')
        }
      })
    },
    // 提交需要转换数据
    parseSendData() {
      const sendObj = {}
      sendObj.stockLog = { ...this.stock }
      sendObj.stockLog.displayMile = parseInt(sendObj.stockLog.displayMile)
      sendObj.stockLog.takeOverManager = parseInt(
        sendObj.stockLog.takeOverManager,
      )

      // 编辑
      if (this.stockId) {
        sendObj.stockLog.id = parseInt(this.stockId)
      } else {
        // 新增需要车辆ID
        sendObj.stockLog.carId = parseInt(this.carId)
        sendObj.stockLog.type = this.stockType
      }
      sendObj.receivableInfos = []
      if (this.payDataList.length) {
        this.payDataList.forEach((item) => {
          if (!item.isGetData) {
            sendObj.receivableInfos.push({ ...item, customerType: 2 })
          }
        })
      }
      //  因为改了入参，所以改变下数据结构
      Object.keys(sendObj.stockLog).forEach((key) => {
        sendObj[key] = sendObj.stockLog[key]
      })
      // sourceType:3强收车；stockType：2入库；recallAmount搜车费用
      if (Number(this.sourceType) === 3 && Number(this.stockType) === 2) {
        sendObj.recallAmount = this.recallCar.recallAmount
      }
      // 处理验车交接文件数据
      sendObj.inspectionAttachment = JSON.stringify([{
        remark: '',
        urlList: this.inspectionAttachmentPlus.map((item) => item.url),
      }])
      // 处理车况照片
      sendObj.photo = JSON.stringify([{
        remark: '',
        urlList: this.photoPlus.map((item) => item.url),
      }])
      return sendObj
    },
    // 处理假分页事件
    getPageData() {
      this.payDataListSlice = this.payDataList.slice(
        (this.pageNum - 1) * this.pageSize,
        this.pageNum * this.pageSize,
      )
    },
    // 返回上一级页面
    goPageBack(status = false) {
      // 从个人租赁订单发车验车进入的直接返回个人租赁订单页面
      if (this.$route.query.from === 'lease') {
        this.$refreshBack(status)
        return
      }

      this.$refreshBack(true)
      // stockType： 1-发车验车 2-退车验车
      const stockTypeMapper = new Map([
        [1, '/vehicle/outInStorage/list'],
        [2, '/vehicle/outInStorage/list'],
        [3, 'car_purchase_order_info'],
      ])
      const path = stockTypeMapper.get(Number(this.stockType))
      this.$router.push({
        path,
      })
    },
  },
}
</script>

<style scoped lang="scss">
.car-details {
  height: 100%;

  .item,
  .info,
  .dialogwrap-add {
    ::v-deep .el-input--small {
      width: 205px;
    }
  }

  .float-right {
    float: right;
  }

  .sumbit-btns {
    text-align: center;
  }
}

.uploadCommon_container {
  display: flex;
}

.imgList {
  padding-right: 12px;
  box-sizing: border-box;
  text-align: right;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  margin-bottom: 30px;
  .imgList_summay {
    display: flex;
    align-items: flex-start;
  }
}

.form-item-tips {
  font-size: 12px;
  color: #666;
  line-height: 20px;
}
.form-item-tips-red {
  font-size: 12px;
  color: red;
  line-height: 20px;
}
.upload-box {
  padding-bottom: 10px;
  &__title {
    font-size: 14px;
    font-weight: 600;
    color: #1D2129;
    .sub-title-line {
      color: #4E5969;
      font-weight: 400;
    }
  }
  &__content {
    &__subtitle {
      font-size: 12px;
      font-weight: normal;
      line-height: 20px;
      color: #86909C;
    }
  }
}
</style>
